import {
  doc,
  deleteDoc
} from "firebase/firestore";

import { dbstatus } from "../firebase";
import Cookies from "js-cookie";

export const Delete_status_message_qry = async (contentid) => {

 

  // VALIDATION
  if (!contentid || !contentid.trim()) {
    return { success: false, error: "Missing contentid" };
  }

  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {

    const tablename = "statusmessage";

    const docRef = doc(dbstatus, tablename, contentid);

    await deleteDoc(docRef);

    return { success: true };

  } catch (err) {

    console.error("❌ Delete_status_message_qry:", err);

    return {
      success: false,
      error: err.message || "Firestore operation failed"
    };

  }
};